import SubscriptionPlanCard from "./subscriptionPlanCard.container";

export default SubscriptionPlanCard;
